import React, { useState } from 'react';
import { Link } from 'react-router-dom';
const API = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | sent | error
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return setError('Please enter your email address.');
    setStatus('loading');
    setError('');
    try {
      await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase().trim() })
      });
      setStatus('sent'); // always show sent — don't reveal if email exists
    } catch {
      setError('Something went wrong. Please try again.');
      setStatus('idle');
    }
  };

  const s = styles;

  if (status === 'sent') {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.icon}>📬</div>
          <h2 style={s.title}>Check your email</h2>
          <p style={s.sub}>
            If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox — it expires in 1 hour.
          </p>
          <p style={s.sub}>Didn't get it? Check spam, or <button style={s.linkBtn} onClick={() => setStatus('idle')}>try again</button>.</p>
          <Link to="/login" style={s.backLink}>← Back to login</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.icon}>🔐</div>
        <h2 style={s.title}>Forgot your password?</h2>
        <p style={s.sub}>No problem. Enter your email and we'll send you a reset link.</p>

        <form onSubmit={handleSubmit} style={s.form}>
          <input
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={s.input}
            autoFocus
          />
          {error && <p style={s.error}>{error}</p>}
          <button type="submit" style={s.btn} disabled={status === 'loading'}>
            {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <Link to="/login" style={s.backLink}>← Back to login</Link>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  card: { background: '#1e293b', borderRadius: '16px', padding: '48px 40px', maxWidth: '420px', width: '100%', textAlign: 'center', boxShadow: '0 25px 50px rgba(0,0,0,0.4)' },
  icon: { fontSize: '48px', marginBottom: '16px' },
  title: { color: '#f1f5f9', fontSize: '24px', fontWeight: '700', margin: '0 0 8px' },
  sub: { color: '#94a3b8', fontSize: '15px', lineHeight: '1.6', margin: '0 0 24px' },
  form: { display: 'flex', flexDirection: 'column', gap: '12px', textAlign: 'left' },
  input: { background: '#0f172a', border: '1px solid #334155', borderRadius: '8px', padding: '12px 14px', color: '#f1f5f9', fontSize: '15px', outline: 'none', fontFamily: 'inherit' },
  btn: { background: 'linear-gradient(135deg, #1e3a8a, #4f46e5)', color: 'white', border: 'none', borderRadius: '8px', padding: '13px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', marginTop: '4px' },
  error: { color: '#f87171', fontSize: '13px', margin: '0' },
  backLink: { display: 'inline-block', marginTop: '24px', color: '#6366f1', fontSize: '14px', textDecoration: 'none' },
  linkBtn: { background: 'none', border: 'none', color: '#6366f1', cursor: 'pointer', fontSize: '14px', padding: 0, fontFamily: 'inherit' }
};
